import { render, staticRenderFns } from "./FamilyConfirmResultTab.vue?vue&type=template&id=9a174b2a&scoped=true&lang=pug"
import script from "./FamilyConfirmResultTab.vue?vue&type=script&lang=ts"
export * from "./FamilyConfirmResultTab.vue?vue&type=script&lang=ts"
import style0 from "./FamilyConfirmResultTab.vue?vue&type=style&index=0&id=9a174b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a174b2a",
  null
  
)

export default component.exports